module.exports = __webpack_public_path__ + "static/media/download-arrow.a7738b4e.svg";